import React from "react";
import { BsPlusSquareFill } from "react-icons/bs";
import { FcManager } from "react-icons/fc";
import { Main_Color } from "../../Theme/Theme";
import Backend from "../../Backend/Backend";
import { useAlert } from "react-alert";
import Modal from "@mui/material/Modal";
import CustomerCard from "./CustomerCard";
import Add from "./Add/Add";
import Edit from "./Edit/Edit";
import Rate from "./Rate/Rate";
import Route from "./Route/Route";
import Stock from "./Stock/Stock";
import hotkeys from "hotkeys-js";
import { AiFillCloseSquare } from "react-icons/ai";
import { InputText } from "primereact/inputtext";

const backend = new Backend();
const Customer = (props) => {
  const input1 = React.useRef();

  const [open, setOpen] = React.useState(false);
  const [data, setData] = React.useState([]);
  const [data_active, setData_Active] = React.useState([]);
  const [data_deactive, setData_Deactive] = React.useState([]);
  const [data_search, setData_Search] = React.useState([]);
  const [loading, setLoading] = React.useState(true);
  const [token, setToken] = React.useState(localStorage.getItem("token"));
  const [adminid, setAdminid] = React.useState(localStorage.getItem("adminid"));
  const [edit_modal, setEdit_modal] = React.useState(false);
  const [rate_modal, setRate_modal] = React.useState(false);
  const [route_modal, setRoute_modal] = React.useState(false);
  const [stock_modal, setStock_modal] = React.useState(false);
  const [editdata, setEditData] = React.useState("");
  const [search, setSearch] = React.useState("");
  const [active, setActive] = React.useState(false);
  const alert = useAlert();

  React.useEffect(() => {
    hotkeys("esc", async (event, handler) => {
      event.preventDefault();
      handleClose();
      handleClose_edit();
    });
    hotkeys("s", async (event, handler) => {
      event.preventDefault();
      input1.current.focus();
    });
    loadconent();
  }, []);

  const loadconent = () => {
    setLoading(true);
    var data = {
      token: token,
      admin_id: adminid,
    };
    backend.load_customer(data).then((r) => {
      if (r.error === "False") {
        var data_active = r.data.filter((x) => x.status == 1);
        var data_deactive = r.data.filter((x) => x.status == 0);
        setData_Active(data_active);
        setData_Deactive(data_deactive);
        setData(data_active);
        setData_Search(r.data);
        setLoading(false);
      } else {
        alert.error("You just broke something!");
        setLoading(false);
      }
    });
  };

  const handleOpen = () => setOpen(true);

  const handleClose = () => setOpen(false);

  const handleOpen_edit = (i) => {
    setEditData(i);
    setEdit_modal(true);
  };

  const handleClose_edit = () => {
    setEdit_modal(false);
    setEditData("");
  };

  const handleOpen_Rate = (i) => {
    setEditData(i);
    setRate_modal(true);
  };

  const handleClose_Rate = () => {
    setRate_modal(false);
    setEditData("");
  };

  const handleOpen_Route = (i) => {
    setEditData(i);
    setRoute_modal(true);
  };

  const handleClose_Route = () => {
    setRoute_modal(false);
    setEditData("");
  };

  const handleOpen_Stock = (i) => {
    setEditData(i);
    setStock_modal(true);
  };

  const handleClose_Stock = () => {
    setStock_modal(false);
    setEditData("");
  };

  const onSearch = (e) => {
    setSearch(e);
    if (e.length > 1) {
      let filteredData = [];
      for (var i = 0; i < data_search.length; i++) {
        if (data_search[i].name.toLowerCase().includes(e.toLowerCase())) {
          filteredData.push(data_search[i]);
        } else if (
          data_search[i].customer_id.toLowerCase().includes(e.toLowerCase())
        ) {
          filteredData.push(data_search[i]);
        }
      }
      setData(filteredData);
    } else {
      setData(data_search);
    }
  };

  const ActiveActive = () => {
    setActive(false);
    setData(data_active);
  };
  const ActiveDeactive = () => {
    setActive(true);
    setData(data_deactive);
  };
  return (
    <div style={{ flex: 1, backgroundColor: "#f2f2f2" }}>
      <div
        style={{
          display: "flex",
          height: "100px",
          backgroundColor: "#ffffff",
          flex: 1,
          alignItems: "center",
        }}
      >
        <div
          style={{
            display: "flex",
            padding: 20,
            color: Main_Color,
            fontSize: 22,
            paddingLeft: 40,
            flex: 1,
            alignItems: "center",
            justifyContent: "flex-start",
          }}
        >
          <FcManager style={{ fontSize: 55 }} />
          <div style={{ paddingLeft: 20, fontSize: 22 }}>Customer</div>
        </div>
        <div
          style={{
            paddingRight: 20,
            fontSize: 22,
            display: "flex",
            alignItems: "center",
            justifyContent: "flex-end",
            flex: 1,
          }}
        >
          <div
            onClick={() => (active ? ActiveActive() : ActiveDeactive())}
            style={{
              marginRight: 20,
              fontSize: 22,
              backgroundColor: active ? "green" : "red",
              padding: 10,
              borderRadius: 7,
              color: "#ffffff",
            }}
          >
            {active ? "Active" : "Deactive"}
          </div>
          <InputText
            ref={input1}
            placeholder="Customer Search...."
            value={search}
            style={{
              width: "300px",
              borderRadius: 0,
              borderTopLeftRadius: 10,
              borderBottomLeftRadius: 10,
            }}
            onChange={(e) => onSearch(e.target.value)}
          />

          <div
            onClick={() => {
              setSearch("");
              loadconent();
            }}
            style={{
              height: "45px",
              backgroundColor: Main_Color,
              width: "45px",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              borderTopRightRadius: 10,
              borderBottomRightRadius: 10,
            }}
          >
            <AiFillCloseSquare
              style={{
                color: "#ffffff",
                height: 40,
                width: 40,
              }}
            />
          </div>
        </div>
        <div
          onClick={handleOpen}
          style={{
            display: "flex",
            padding: 20,
            color: Main_Color,
            fontSize: 22,
            paddingRight: 40,
          }}
        >
          <BsPlusSquareFill style={{ fontSize: 40 }} />
        </div>
      </div>

      <div style={{ padding: 10 }}>
        <div
          style={{
            flex: 1,
            height: "83vh",
            borderRadius: 10,
            overflowY: "scroll",
          }}
        >
          {loading === true ? (
            <div
              style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                flex: 1,
                backgroundColor: "#ffffff",
                height: "100%",
              }}
            >
              <img src={require("../../Image/loading.gif")} />
            </div>
          ) : data.length > 0 ? (
            data.map((i, t) => {
              return (
                <CustomerCard
                  item={i}
                  index={t}
                  edit_modal={(i) => handleOpen_edit(i)}
                  rate_modal={(i) => handleOpen_Rate(i)}
                  route_modal={(i) => handleOpen_Route(i)}
                  stock_modal={(i) => handleOpen_Stock(i)}
                />
              );
            })
          ) : (
            <div
              style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                flex: 1,
                backgroundColor: "#ffffff",
                height: "100%",
                flexDirection: "column",
              }}
            >
              <img src={require("../../Image/noData.gif")} height={"300px"} />
              <div style={{ fontSize: 22, color: "gray" }}>
                No Customer Found
              </div>
            </div>
          )}
        </div>
      </div>
      <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Add
          close={(a) => {
            if (a == "a") {
              handleClose(false);
            } else {
              handleClose(false);
              loadconent();
            }
          }}
        />
      </Modal>
      <Modal
        open={edit_modal}
        onClose={handleClose_edit}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Edit
          close={(a) => {
            if (a == "a") {
              handleClose_edit(false);
            } else {
              loadconent();
              handleClose_edit(false);
            }
          }}
          data={editdata}
        />
      </Modal>
      <Modal
        open={rate_modal}
        onClose={handleClose_Rate}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Rate
          close={(a) => {
            if (a == "a") {
              handleClose_Rate(false);
            } else {
              loadconent();
              handleClose_Rate(false);
            }
          }}
          data={editdata}
        />
      </Modal>
      <Modal
        open={route_modal}
        onClose={handleClose_Route}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Route
          close={(a) => {
            if (a == "a") {
              handleClose_Route(false);
            } else {
              loadconent();
              handleClose_Route(false);
            }
          }}
          data={editdata}
        />
      </Modal>
      <Modal
        open={stock_modal}
        onClose={handleClose_Stock}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Stock
          close={(a) => {
            if (a == "a") {
              handleClose_Stock(false);
            } else {
              loadconent();
              handleClose_Stock(false);
            }
          }}
          data={editdata}
        />
      </Modal>
    </div>
  );
};

export default Customer;
